
import { Vue, Component } from 'vue-property-decorator'
import { CommonService } from '@/services'

@Component({})
export default class ListTitle extends Vue {
    private sort = 'created_at'
    private pageIndex = 1
    private pageSize = 10
    private pageTotal = 0
    private isLoading = false
    private DialogVisible = false
    private currTitle = ''
    private titleInput = ''
    private eventData = []
    private sortOptions = [
        {
            value: 'created_at',
            label: '按创建时间排序'
        }, {
            value: 'updated_at',
            label: '按更新时间排序'
        }, {
            value: 'start_at',
            label: '按开始时间排序'
        }, {
            value: 'news_count',
            label: '按文章数排序'
        }
    ]

    private mounted() {
        this.getEventList()
    }

    // 去往详情页
    private toDetail(item: any) {
        this.$router.push(`/event/${item.id}`)
    }

    // 获取事件列表
    private async getEventList() {
        const params = {
            title: this.titleInput,
            sort: this.sort,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await CommonService.getEventList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.eventData = result.data.list
            this.pageTotal = result.data.page_total
        }
    }

    private onCurrentChange(currPage: number) {
        this.pageIndex = currPage
        this.getEventList()
    }

    private onSelectChange() {
        this.getEventList()
    }

    private onSearch() {
        this.getEventList()
    }
}
